import { render, staticRenderFns } from "./batchCheckDlg.vue?vue&type=template&id=38b4063a&scoped=true"
import script from "./batchCheckDlg.vue?vue&type=script&lang=js"
export * from "./batchCheckDlg.vue?vue&type=script&lang=js"
import style0 from "./batchCheckDlg.vue?vue&type=style&index=0&id=38b4063a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b4063a",
  null
  
)

export default component.exports